import { DashboardLayout } from "components";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAuthenticated, logOut, hasPermission } from "utils/helper";
import { ROUTES } from "./routePaths";

const AuthenticatedRoute = ({ children, canAccess, fullWidth }) => {
  const { user } = useSelector((state) => state.user);

  // return (
  //   <DashboardLayout fullWidth={fullWidth}>{children}</DashboardLayout>
  // );

  //Be sure to check it has can access. If not dont check for 403
  //Dashboard and onboarding pages for example

  if (isAuthenticated()) {
    //Check to ensure Agents and Aggregators are forced to provide NIN
    if (!user?.nin && !user?.user_type.toLowerCase().includes("admin"))
      return <Navigate to={ROUTES.requestNin} />;

    if (!canAccess || hasPermission(canAccess, user?.authorities))
      return (
        <DashboardLayout fullWidth={fullWidth}>{children}</DashboardLayout>
      );

    return <Navigate to={ROUTES.dashboard} />;
  }

  logOut();
};

export default AuthenticatedRoute;
